import React from 'react';
import PropTypes from 'prop-types';
import { LuBuilding2, LuFileSpreadsheet, LuMap, LuPlus, LuUsersRound } from 'react-icons/lu';
import PageHero from '../../../components/data/PageHero';
import Button from '../../../components/ui/Button';
import useCenterText from '../centerText';

/** Title card of Merkez Yönetimi with the page actions. */
const CenterHeader = ({ onRegions, onSmoOverview, onExcel, onAdd }) => {
  const { label } = useCenterText();
  const iconButton = 'max-sm:tw-w-10 max-sm:tw-px-0';
  return (
    <PageHero
      icon={LuBuilding2}
      gradient="tw-from-sky-400 tw-to-blue-600 tw-shadow-blue-500/30"
      title={label('page.title')}
      subtitle={label('page.subtitle')}
      // Phones: "new center" across the row, the rest as icon buttons; wider
      // screens wrap instead of running out of the card
      actionsClassName="tw-grid tw-grid-cols-[repeat(3,auto)_minmax(0,1fr)] tw-items-center tw-gap-2 sm:tw-flex sm:tw-flex-wrap lg:tw-max-w-[calc(100%-22rem)] lg:tw-justify-end"
    >
      <Button onClick={onRegions} aria-label={label('actions.regions')} title={label('actions.regionsHint')} className={iconButton}>
        <LuMap aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-teal-600 dark:tw-text-teal-300" />
        <span className="tw-hidden sm:tw-inline">{label('actions.regions')}</span>
      </Button>
      <Button onClick={onSmoOverview} aria-label={label('actions.smo')} title={label('actions.smoHint')} className={iconButton}>
        <LuUsersRound aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-violet-600 dark:tw-text-violet-300" />
        <span className="tw-hidden sm:tw-inline">{label('actions.smo')}</span>
      </Button>
      <Button onClick={onExcel} aria-label={label('actions.excel')} title={label('actions.excelHint')} className={iconButton}>
        <LuFileSpreadsheet aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-emerald-600 dark:tw-text-emerald-400" />
        <span className="tw-hidden sm:tw-inline">{label('actions.excel')}</span>
      </Button>
      <Button variant="primary" onClick={onAdd} className="max-sm:tw-w-full">
        <LuPlus aria-hidden="true" className="tw-h-4 tw-w-4" strokeWidth={2.5} />
        {label('actions.add')}
      </Button>
    </PageHero>
  );
};

CenterHeader.propTypes = {
  onRegions: PropTypes.func.isRequired,
  onSmoOverview: PropTypes.func.isRequired,
  onExcel: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default CenterHeader;
